import React from 'react';
import type {UserGroupSimpleResponse} from 'src/api/ProactApiClient';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {TableToolbar} from 'src/design/molecules/TableToolbar';
import {PermissionGuard} from 'src/app/security/authorization/PermissionGuard';
import {SidebarLinkUserGroupsAdmin} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {UserGroupTable} from 'src/app/user-groups/UserGroupTable/UserGroupTable';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {UserGroupDocumentTitle} from 'src/app/user-groups/userGroupHelpers';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const UserGroupListPage: React.FC = () => {
  useSetDocumentTitle(UserGroupDocumentTitle);
  const navigate = useAppNavigate();

  const handleNavigateToUserGroup = (obj: UserGroupSimpleResponse) => {
    navigate(PathUtility.UserGroupView(obj.id, 'content'));
  };

  const handleAddNew = () => navigate(PathUtility.UserGroupCreate('content'));

  return (
    <ContentWrapper>
      <PageHeader>
        <PageHeader.Title
          icon={SidebarLinkUserGroupsAdmin.icon}
          subtitle="Manage user groups and permissions">
          Groups
        </PageHeader.Title>
      </PageHeader>
      <UserGroupTable
        identifier="user-group-list-page"
        onViewRowClick={handleNavigateToUserGroup}
        actionBarPreNode={
          <PermissionGuard
            module={ModuleEnum.UserGroups}
            operation={PermissionOperationEnum.Create}
            allowGlobalAdminBypass={true}>
            <TableToolbar.Action variant="create" onClick={handleAddNew}>
              New Group
            </TableToolbar.Action>
          </PermissionGuard>
        }
      />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.UserGroup(),
  element: <UserGroupListPage />,
  module: ModuleEnum.UserGroups,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default UserGroupListPage;
